import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMathGamma = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10.25 13.5c-.13 2.602-.609 4.185-.75 4.75m.75-4.75c.218-4.323-1.72-8.506-4.5-11.75m4.5 11.75c.25-2 1.75-7 4-9.75"
	})]
});
const ForwardRef = forwardRef(SvgMathGamma);
export { ForwardRef as ReactComponent };
